export const Constants = {
  TAG_NAME: 'pop-pc-price-table-component',
  TRANSLATION_KEYS: {
    NAV_PRICE: 'tables.price.headers.nav_price',
    APPLICATION_PRICE: 'tables.price.headers.application_price',
    WITHDRAWAL_PRICE: 'tables.price.headers.withdrawal_price',
    PRICE_AS_OF: 'tables.price.headers.price_as_of',
    PERFORMANCE_REPORT: 'tables.price.headers.performance_report',
    QUARTERLY_REVIEW: 'tables.price.headers.quarterly_review',
  },
  PRICE_COLUMN_IDS: {
    PRODUCT_NAME: 'product-name',
    NAV_PRICE: 'navPrice',
    APPLICATION_PRICE: 'applicationPrice',
    WITHDRAWAL_PRICE: 'withdrawalPrice',
    PRICE_AS_OF: 'priceAsOfDate',
    PERFORMANCE_REPORT: 'performance-report',
    QUARTERLY_REVIEW: 'quarterly-review',
  },
  TABLE_ELEMENT_TYPE: {
    product: 'product',
  },
  RATING_ROW_CLASS: 'b-flex b-justify-center',
  REPORT_ROW_CLASS: 'b-flex b-justify-center',
} as const;
